// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qwYgS","rootMobile":"styles_rootMobile__3j_QU"};